import React from "react";
import PropTypes from "prop-types";
import DashedTooltip from "components/UI/DashedTooltip";
import { returnUpDownClassname } from "utils/helpers";

const formatUsd = (value) =>
  `$${value.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

// Slim one-line P&L figures above a table (Strategies / Trades History); the
// Trading page's KPI cards show the account-wide numbers.
const PnlSummaryLine = ({ items }) => (
  <div className="flex flex-wrap gap-x-6 gap-y-1 pb-3 text-sm">
    {items.map(({ label, tooltip, value, percent }) => (
      <span key={label}>
        <DashedTooltip text={tooltip}>{label}</DashedTooltip>:{" "}
        <b className={returnUpDownClassname(value)}>
          {formatUsd(value)}
          {percent != null && ` (${percent}%)`}
        </b>
      </span>
    ))}
  </div>
);

PnlSummaryLine.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
      value: PropTypes.number.isRequired,
      percent: PropTypes.number,
    }),
  ).isRequired,
};

export default PnlSummaryLine;
